import React, { useState } from "react";

import { Journey } from "models/Journey";
import { AirBundleSubscription } from "models/userPolicy/AirBundleSubscription";

import AirBundleAppliedModal from "../AirBundleAppliedModal";
import AirBundleRejectedModal from "../AirBundleRejectedModal";

interface IComponent {
  journey: Journey;
  airBundleSubscriptionData: AirBundleSubscription;
  userDidNotSelectAirLuggage: boolean;
}

const AirBundleModal: React.FC<IComponent> = ({ journey, airBundleSubscriptionData, userDidNotSelectAirLuggage }) => {
  const [showAirBundleRejectedModal, setShowAirBundleRejectedModal] = useState(false);

  const hasAirPayout = journey.hasAirPayout;
  const hasAirLuggage = journey.hasAirLuggage;

  const isAirBundleApplied = hasAirPayout || (showAirBundleRejectedModal && hasAirLuggage);

  if (isAirBundleApplied) {
    return <AirBundleAppliedModal airBundleSubscriptionData={airBundleSubscriptionData} journey={journey} />;
  }

  return (
    <AirBundleRejectedModal
      journey={journey}
      airBundleSubscriptionData={airBundleSubscriptionData}
      setShowAirBundleRejectedModal={setShowAirBundleRejectedModal}
      userDidNotSelectAirLuggage={userDidNotSelectAirLuggage}
    />
  );
};

export default AirBundleModal;
